import { Empresa } from './empresa';
import { Serializable } from './commom/serializable';
import { ItemPedido } from './ItemPedido';

export class Pedido implements Serializable<Pedido> {
    public Id: number;    
    public Empresa: Empresa;
    public IdUsuario: number;  
    public PrimeiraCartela: string; 
    public SegundaCartela: string; 
    public CodRepresentante: number;
    public ImgFrente: string;      
    public ImgVerso: string; 
    public Obs: string; 
    public ItemPedido: ItemPedido[];
    public TotPedido: number;

    deserialize(input: Object): Pedido {
        Object.assign(this, input);

        return this;
    }
}


// WEBPACK FOOTER //
// ./src/entities/pedido.ts